import { Box, Link } from '@mui/material';

import { Icon } from '../../shared/Icon';

export interface JiraIssueLinkProps {
    url: string;
}

/** External link to a Jira issue or subtask, styled for giftsv2. */
export const JiraIssueLink = ({ url }: JiraIssueLinkProps) => (
    <Link
        href={url}
        target="_blank"
        rel="noreferrer"
        underline="hover"
        onClick={(event) => event.stopPropagation()}
        sx={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 0.5,
            fontSize: '0.8rem',
            fontWeight: 600,
            whiteSpace: 'nowrap',
        }}
    >
        <Box component="span" sx={{ display: 'flex', fontSize: 16 }}>
            <Icon name="open_in_new" />
        </Box>
        Jira
    </Link>
);
